'use client';

import SettingsSwitch from 'src/components/Settings/components/SettingsSwitch';
import { Settings } from 'src/components/Settings/SettingsForm';
import ThemeSettingButtonGroup from 'src/components/Settings/InterfaceSettings/ThemeSettingButtonGroup';
import Divider from 'src/components/primitives/Divider/Divider';
import useInterfaceSettings from 'src/components/Settings/InterfaceSettings/hooks/useInterfaceSettings';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';

interface Props {
	localSettings: Settings;
	setLocalSettings: (settings: Settings) => void;
}

export default function InterfaceSettings({
	localSettings,
	setLocalSettings,
}: Props) {
	const { generalSettings, chartSettings } = useInterfaceSettings();
	const isEmbeddedWalletFlagEnabled = useFeatureFlagStore((s) =>
		s.flagEnabled('ENABLE_EMBEDDED_WALLET')
	);

	const handleChartSettingChange = (key: keyof Settings) => {
		setLocalSettings({
			...localSettings,
			[key]: !localSettings[key],
		});
	};

	return (
		<div className="flex flex-col gap-y-lg">
			{isEmbeddedWalletFlagEnabled && (
				<>
					<SettingsSwitch
						className="typo-label-sm"
						label="Enable Signless Trading"
						checked={localSettings.enableSignlessTrading}
						onChange={() =>
							setLocalSettings({
								...localSettings,
								enableSignlessTrading: !localSettings.enableSignlessTrading,
							})
						}
					/>
					<Divider />
				</>
			)}
			{generalSettings.map(({ label, key }) => (
				<SettingsSwitch
					key={key}
					className="typo-label-sm"
					label={label}
					checked={!!localSettings[key]}
					onChange={() =>
						setLocalSettings({
							...localSettings,
							[key]: !localSettings[key],
						})
					}
				/>
			))}
			<Divider />
			{chartSettings.map(({ label, key }) => (
				<SettingsSwitch
					key={key}
					className="typo-label-sm"
					label={label}
					checked={!!localSettings[key]}
					onChange={() => handleChartSettingChange(key)}
				/>
			))}
			<Divider />
			<ThemeSettingButtonGroup
				labelClassName="typo-label-sm"
				value={localSettings.theme}
				onChange={(theme) => setLocalSettings({ ...localSettings, theme })}
			/>
		</div>
	);
}
